export default {
  MESSAGE_OVERVIEW: "message_overview",
  CUSTOMER_OVERVIEW: "customer_overview",
  PACKAGE_OVERVIEW: "package_overview",
};
